export default __webpack_public_path__ + "static/media/image_efficacy-bubbles.8de80e66.svg";